import { FC, HTMLAttributes } from 'react';

export const ReactComponent: FC<HTMLAttributes<SVGElement>> = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="#5D6688"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M16.2236 8.05273L15.7764 8.94727L10.5 6.30859V17H17V18H3V17H9.5V5.80859L3.77637 2.94727L4.22363 2.05273L16.2236 8.05273Z" />
    <path d="M15 10C16.6569 10 18 11.3431 18 13V14H12V13C12 11.3431 13.3431 10 15 10Z" />
    <path d="M5 6C6.65685 6 8 7.34315 8 9V10H2V9C2 7.34315 3.34315 6 5 6Z" />
  </svg>
);
